export default __webpack_public_path__ + "media/zurb/img/home/hulu-press-f49e6cd7459e5d88d26ef649461a9615.webp";